import { Component, OnInit } from '@angular/core';
import { showNotification } from 'src/app/helpers/show-toast';
import { Test } from 'src/app/_models/test.model';
import { TestsService } from 'src/app/_services/tests.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { DeleteModalComponent } from 'src/app/components/delete-modal/delete-modal.component';
import { sortTable } from 'src/app/helpers/sort-table';

@Component({
  selector: 'app-tests-list',
  templateUrl: './tests-list.component.html',
  styleUrls: ['./tests-list.component.scss'],
})
export class TestsListComponent implements OnInit {
  pageTitle: string = 'Tests';
  placeholder: string = 'Search by test name …';
  testArray: Test[];
  filteredTestArray: Test[];
  invertSort: boolean = false;
  theadArray = [
    'Test EN Name',
    'Test AR Name',
    'Test Type',
    'Covid Test',
    'Bundle Test',
    'Test Actions',
  ];

  modalRef: BsModalRef;
  searchString: string = '';
  isDataFilteredAfterSearch: boolean = false;
  pageId: number = 1;

  constructor(
    private testService: TestsService,
    public toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.handleGetTestsByTypeId(this.pageId);
  }

  getAllTests() {
    this.testService.getAllTests().subscribe((res) => {
      this.testArray = res.data.tests;
      this.filteredTestArray = this.testArray;
    });
  }

  onSearchTest(searchString) {
    if(searchString){
      this.searchString = searchString;
      this.isDataFilteredAfterSearch = true;
      this.testService.searchTestByName(searchString, this.pageId - 1).subscribe((response) => {
        this.filteredTestArray = response['data']['tests'];
      })
    }
  }

  onSearchInputKeyup(searchString) {
    this.searchString = searchString;
    if (!searchString && this.isDataFilteredAfterSearch) {
      this.filteredTestArray = [...this.testArray];
    }
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredTestArray = sortTable(
      this.filteredTestArray,
      'name',
      this.invertSort
    );
  }

  onCovidChange(event, test) {
    test.isCovid = event.target.checked;

    this.testService.updateTest(test).subscribe((response) => {
      showNotification(
        'success',
        `${response.data.name} test has ${response.data.isCovid ? 'covid' : 'not covid'}`,
        this.toastr
      );
    });
  }

  onBundleChange(event, test) {
    test.isBundle = event.target.checked;

    this.testService.updateTest(test).subscribe((response) => {
      showNotification(
        'success',
        `${response.data.name} test has ${response.data.isBundle ? 'bundle' : 'not bundle'}`,
        this.toastr
      );
    });
  }

  onDeleteTest(event, item): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.id,
        itemName: item.name,
      },
    };

    this.modalRef = this.modalService.show(DeleteModalComponent, initialState);

    this.modalRef.content.event.subscribe((data) => {
      this.onDeleteTestSubmit(item.name, data);
    });
  }

  onDeleteTestSubmit(testName, testId) {
    this.testService.deleteTest(testId).subscribe((res) => {
      showNotification('success', `${testName} has been deleted`, this.toastr);

      this.testArray = this.testArray.filter((test) => test.id !== testId);

      this.filteredTestArray = [...this.testArray];

      this.modalRef.hide();
    });
  }

  changePageId(pageId: number) {
    this.pageId = pageId;
    this.handleGetTestsByTypeId(pageId);
  }

  handleGetTestsByTypeId(typeId: number) {
    this.testService.getTestsByTypeId(typeId - 1)
      .subscribe(res => {
        this.testArray = res.data.tests;
        this.filteredTestArray = res.data.tests;
        this.isDataFilteredAfterSearch = false;
        this.searchString = '';
      });
  }
}
